module.exports = __webpack_public_path__ + "static/media/img02_special_img.149014ed.png";